/**
 * Routing utilities for handling base URL configuration
 */

/**
 * Get the base URL from environment configuration
 */
export function getBaseUrl(): string {
  return import.meta.env.VITE_BASE_URL || '/';
}
